import { ajaxPromise } from './request_helpers';
import { BELAY_JWT_TOKEN } from '../../microapps/Community/constants';

const localBelayRoot = 'http://localhost:3001';

const getBelayJwtToken = (id = 20554437) => {
  const data = JSON.stringify({ id });

  return ajaxPromise({
    type: 'POST',
    url: `${localBelayRoot}/_token`,
    headers: {
      'content-type': 'application/json'
    },
    data
  });
};

const belayToken = async () => {
  const cachedToken = window.localStorage.getItem(BELAY_JWT_TOKEN);

  if (cachedToken) {
    return cachedToken;
  }

  const { token } = await getBelayJwtToken();
  window.localStorage.setItem(BELAY_JWT_TOKEN, token);
};

const belayAjaxPromise = async options => {
  // ALL LOGIC for the belay token is for development only, as we work towards
  // getting a more production ready system the token logic will be removed and
  // authentication will be handled on the backend.
  if (options.type && options.type !== 'GET' && !options.contentType) {
    options.contentType = 'application/json; charset=utf-8';
    if (typeof options.data !== 'string') {
      options.data = JSON.stringify(options.data);
    }
  }
  if (!options.headers) {
    options.headers = {};
  }

  const jwt = await belayToken();
  options.headers = { ...options.headers, Authorization: `bearer ${jwt}` };
  return ajaxPromise(options);
};

const getFollowerRequests = (userId = 20554437) => {
  return belayAjaxPromise({
    method: 'GET',
    url: `${localBelayRoot}/connect/users/${userId}?include=follow-requests.received`,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const userActionRequest = (href, method) => {
  return belayAjaxPromise({
    method,
    url: `${localBelayRoot}${href}`
  });
};

const getFacebookUploadStatus = (userId = 20554437) => {
  return belayAjaxPromise({
    method: 'GET',
    url: `${localBelayRoot}/connect/users/${userId}?include=contact-uploads.facebook`,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const uploadFacebookTokenToBelay = (token, userId = 20554437) => {
  const data = JSON.stringify({ token, source: 'facebook' });

  return belayAjaxPromise({
    method: 'PUT',
    url: `${localBelayRoot}/connect/users/${userId}/contact-uploads/facebook`,
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });
};

const getContactOfFriends = (userId = 20554437) => {
  return belayAjaxPromise({
    method: 'GET',
    url: `${localBelayRoot}/connect/users/${userId}?include=contacts`,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export { getBelayJwtToken, getFollowerRequests, userActionRequest, getFacebookUploadStatus, uploadFacebookTokenToBelay, getContactOfFriends };
